import { createContext, useReducer } from "react";
import GithubReducer from "./GithubReducer";

const GithubContext = createContext()

// const GITHUB_URL = process.env.REACT_APP_GITHUB_URL 
// const GITHUB_TOKEN = process.env.REACT_APP_GITHUB_TOKEN 

export const GithubProvider = ({children}) => {
    const initialState = {
        users: [],
        user: {},
        repos: [],
        loading: false
    }

    const [state, dispatch] = useReducer(GithubReducer, initialState)
    
    // Functions moved to GithubActions- left here as an example of other possibilities.
    // // Get search results from API
    // const searchUsers = async (text) => {
    //     setLoading()

    //     const params = new URLSearchParams({
    //         q:text
    //     })

    //     const response = await fetch(`${GITHUB_URL}/search/users?${params}`, {
    //         headers: {
    //             Authorization: `token ${GITHUB_TOKEN}`,
    //         },
    //     })

    //     const {items} = await response.json()
    //     dispatch({
    //         type: 'GET_USERS',
    //         payload: items,
    //     })
    // }

// //get single user
// const getUser = async (login) => {
//         setLoading()

//         const response = await fetch(`${GITHUB_URL}/users/${login}`, {
//             headers: {
//                 Authorization: `token ${GITHUB_TOKEN}`,
//             },
//         })

//         if(response.status === 404) {
//             window.location = '/notfound'
//         } else {

//         const data = await response.json()
//         dispatch({
//             type: 'GET_USER',
//             payload: data,
//         })
//     }
//     }

//     const getUserRepos = async (login) => {
//         setLoading()

//         const params = new URLSearchParams({
//             sort: 'created',
//             per_page: 10,
//         })

//         const response = await fetch(`${GITHUB_URL}/users/${login}/repos?${params}`, {
//             headers: {
//                 Authorization: `token ${GITHUB_TOKEN}`,
//             },
//         })

//         const data = await response.json()
//         dispatch({
//             type: 'GET_REPOS',
//             payload: data,
//         })
//     }

    // //Clear users from state after search
    // const clearUsers = () => {
    //     dispatch({
    //         type: 'CLEAR_USERS'
    //     })
    // }

    // const setLoading = () => dispatch({type: 'SET_LOADING'})

    return (<GithubContext.Provider value={{
        ...state,
        dispatch,
        }}>
        {children}
        </GithubContext.Provider>)
    
}

export default GithubContext